import { IPublicationCard } from '@interfaces'

export const getFilterPublications = (
  collection: IPublicationCard[],
  type: 'Sergi Katalogları' | 'Çocuk Yayınları' | 'Bilimsel Yayınlar'
) => {
  return collection.filter((row) => row.type === type)
}
